import { keepPreviousData, queryOptions } from '@tanstack/react-query'

import { fetchPerformance } from './api'
import { formatInputDate } from './date-range'
import type { DateRange } from './date-range'
import type { PerformancePeriod, PerformanceQuery } from './schema'

export const reportsKeys = {
  all: ['reports'] as const,
  performance: (query: PerformanceQuery) =>
    [...reportsKeys.all, 'performance', query.period, query.startDate, query.endDate] as const,
}

/** ISO `yyyy-mm-dd` for the API, derived from a selected range + period. */
function toPerformanceQuery(period: PerformancePeriod, range: DateRange): PerformanceQuery {
  return {
    period,
    startDate: toIsoDate(range.start),
    endDate: toIsoDate(range.end),
  }
}

function toIsoDate(date: Date): string {
  const [day, month, year] = formatInputDate(date).split('/')
  return `${year}-${month}-${day}`
}

/**
 * Performance metrics for the selected period + date range. Backed by the
 * dummy API today; the query shape already matches the real endpoint, so no
 * caller changes when the backend lands.
 */
export function performanceQueryOptions(period: PerformancePeriod, range: DateRange) {
  const query = toPerformanceQuery(period, range)
  return queryOptions({
    queryKey: reportsKeys.performance(query),
    queryFn: ({ signal }) => fetchPerformance(query, signal),
    // Keep the previous chart on screen while the next period/range loads.
    placeholderData: keepPreviousData,
    staleTime: 60_000,
  })
}
